module.exports = __webpack_public_path__ + "static/media/caseObj.347e1599.png";